import { render } from "./ChangeItemStateModal.vue?vue&type=template&id=35e5fc83&scoped=true"
import script from "./ChangeItemStateModal.vue?vue&type=script&lang=js"
export * from "./ChangeItemStateModal.vue?vue&type=script&lang=js"

import "./ChangeItemStateModal.vue?vue&type=style&index=0&id=35e5fc83&scoped=true&lang=less"

import exportComponent from "C:\\REPOS\\pos-web-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35e5fc83"]])

export default __exports__